import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const InstitutionRegisterDirective = angularDirectiveToReact('institutionRegister', {
    urlPrefix: 'urlPrefix',
});

export function InstitutionRegisterComponent() {
    const [key, params] = useAngularToReactRoute<{ urlPrefix: string }>();
    return <InstitutionRegisterDirective key={key} {...params} />;
}
